import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { getPackagesInfo } from './index.thunk';

export interface ITrial {
  durationType: 'trial';
  descriptor: 'proTrial' | 'enterpriseTrial';
  startDateUtc: string;
  endDateUtc: string;
}
export interface IPackageInfo {
  trial: ITrial[];
}

interface IPackagesInfoState {
  loading: boolean;
  current: IPackageInfo;
  past: IPackageInfo;
}

export interface IPackageInfoPayload {
  packagesInfo: {
    current: IPackageInfo;
    past: IPackageInfo;
  };
}

export const initialState: IPackagesInfoState = {
  loading: false,
  current: { trial: [] },
  past: { trial: [] }
};

const packagesSlice = createSlice({
  name: 'packagesInfo',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPackagesInfo.pending, (state) => {
        state.loading = true;
        state.current = { trial: [] };
        state.past = { trial: [] };
      })
      .addCase(getPackagesInfo.fulfilled, (state: IPackagesInfoState, action: PayloadAction<IPackageInfoPayload>) => {
        state.loading = false;
        state.current = action.payload.packagesInfo.current;
        state.past = action.payload.packagesInfo.past;
      })
      .addCase(getPackagesInfo.rejected, () => initialState);
  }
});

export const PackagesInfoReducer = packagesSlice.reducer;
export const actions = packagesSlice.actions;
export const caseReducers = packagesSlice.caseReducers;
